export const GUEST_STACK_KEY = 'wowrolla_guest_stack';

const getGuestStackStorage = () => {
  if (typeof window === 'undefined') return null;
  try {
    return window.sessionStorage;
  } catch {
    return null;
  }
};

export const normalizeIdentifier = (value) => {
  if (value === null || value === undefined) return '';
  return String(value).trim();
};

export const resolveItemId = (item) =>
  normalizeIdentifier(item?.tool_slug || item?.slug || item?.tool_id || item?.id || item?.toolId || item?.tool?.id || '');

export const parseGuestStack = () => {
  try {
    const raw = getGuestStackStorage()?.getItem(GUEST_STACK_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};

export const saveGuestStack = (items) => {
  getGuestStackStorage()?.setItem(GUEST_STACK_KEY, JSON.stringify(Array.isArray(items) ? items : []));
};

export const clearGuestStack = () => {
  getGuestStackStorage()?.removeItem(GUEST_STACK_KEY);
};

export const mergeGuestStackTools = (currentItems = [], tools = []) => {
  const existingIds = new Set((currentItems || []).map((item) => resolveItemId(item)).filter(Boolean));
  const additions = (tools || []).filter((tool) => !existingIds.has(resolveItemId(tool)));
  return [...(currentItems || []), ...additions];
};

export const removeGuestStackTool = (currentItems = [], toolId) => {
  const normalized = normalizeIdentifier(toolId);
  if (!normalized) return [...(currentItems || [])];
  return (currentItems || []).filter((item) => resolveItemId(item) !== normalized);
};

